<template>
  <RevCard
    class="h-full border-transparent"
    data-qa="productCard"
    :hoverable="true"
  >
    <ProductCardLayout :product="layoutProduct">
      <template #tag>
        <div class="text-static-danger-hi caption-bold">
          {{ i18n(translations.cardLabel) }}
        </div>
      </template>
      <template #titles-second-row>
        <RevButtonBase
          class="after:focus-visible-outline-default-hi after:rounded-lg after:absolute after:inset-0 after:bg-transparent focus-visible:outline-none"
          :to="props.url"
        >
          <span class="body-1-bold">{{ props.title }}</span>
        </RevButtonBase>
      </template>
      <template #product-info>
        <RevRating :score="0" :show-score-label="false" size="extra-small" />
        <div>
          <div class="caption-bold">
            {{ i18n(translations.priceStartAt) }}
          </div>
          <div class="heading-2">
            {{ i18n(translations.price) }}
          </div>
          <div class="text-static-default-low body-2 line-through">
            {{ i18n(translations.strikedPrice) }}
          </div>
        </div>
      </template>
      <template #image>
        <RevIllustration
          alt=""
          data-test="product-card-image"
          :height="128"
          sizes="128px"
          :src="imageSrc"
          :width="128"
        />
      </template>
    </ProductCardLayout>
  </RevCard>
</template>

<script lang="ts" setup>
import { computed } from 'vue'

import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevButtonBase } from '@ds/components/ButtonBase'
import { RevCard } from '@ds/components/Card'
import { RevIllustration } from '@ds/components/Illustration'
import { RevRating } from '@ds/components/Rating'

import type { Product } from '../../models/product'

import type { ProductCardProduct } from './ProductCard.types'
import translations from './ProductCardComingSoonProduct.translations'
import ProductCardLayout from './ProductCardLayout.vue'

const props = defineProps<{
  variant: 'primary' | 'secondary'
  title: string
  url: ProductCardProduct['url']
}>()

const i18n = useI18n()
const layoutProduct = {
  listingId: 'comingSoonProduct',
  rawProduct: {} as Product,
} as ProductCardProduct

const imageSrc = computed(() => {
  return props.variant === 'primary'
    ? '/img/product-card/Iphone17-Yellow.png'
    : '/img/product-card/Iphone17-Black.png'
})
</script>
